import { RootState } from "store/store";

export const selectTaxonomyOptionsByRole = (state: RootState) =>
  state.profile.taxonomyOptionsByRole;
export const selectTaxonomyOptionsByRoleRequestStatus = (state: RootState) =>
  state.profile.taxonomyOptionsByRoleRequestStatus;
export const selectProfileUpdateStatus = (state: RootState) =>
  state.profile.profileUpdateStatus;
export const selectProfileRequestStatus = (state: RootState) =>
  state.profile.profileRequestStatus;
export const selectProfileFilterRole = (state: RootState) =>
  state.profile.profileFilterRole;
